/**
 * GET TS TO MINUTES
 * @param {Number} ts date as timestamp in second (like python TS)
 * @return {Number} Human readable minutes
 */

export default {
  methods: {
    getTsToMinutes(ts) {
      const minutes = new Date(ts * 1000).getMinutes();
      return minutes;
    },
  },
};
